<template>
    <div class="modal fade slide-right" id="resignModal" tabindex="-1" role="dialog" aria-hidden="true" data-backdrop="static">
        <div class="modal-dialog modal-sm">
            <div class="modal-content-wrapper">
                <div class="modal-content">
                    <div class="modal-header clearfix text-left">
                        <button type="button" class="close" data-dismiss="modal" aria-hidden="true"><i
                                class="pg-close fs-14"></i>
                        </button>
                        <h5>Démisionner {{representative.person.first_name}} {{representative.person.last_name}}</h5>
                        <h5>le {{endDate}}</h5>
                    </div>
                    <div class="modal-body">
                        <p class="no-margin">Etes vous sur?</p>
                    </div>
                    <div class="modal-footer">
                        <button type="button" @click="resign(representative)"
                                class="btn btn-primary btn-cons pull-left inline" data-dismiss="modal">
                            Démissioner

                        </button>
                        <button type="button" class="btn btn-default btn-cons no-margin pull-left inline"
                                data-dismiss="modal" @click="$emit('cancel')">Annuler
                        </button>
                    </div>
                </div>
            </div>
            <!-- /.modal-content -->
        </div>
        <!-- /.modal-dialog -->
    </div>
</template>

<script>

    export default {

        props: ["representative", "resign"],

        mounted () {
            $(this.$el).modal()
        },

        beforeDestroy () {
            $(this.$el).modal('hide')
            $('body').removeClass('modal-open')
            $('.modal-backdrop').remove()
        },

        computed: {
            endDate () {
                return moment(this.representative.representative_end_date).format('LL')
            }
        },
    }
</script>

<style lang="css">
</style>



// WEBPACK FOOTER //
// client/components/Customer/RepresentativesContent/ResignModal.vue